module.exports = __webpack_public_path__ + "98a7065b410431a22fcc247700737845.png";